// @flow

import { Query } from '@apollo/react-components';

import type { GraphqlQueryControls } from '@apollo/react-common';

export type fetchMoreType = $PropertyType<GraphqlQueryControls, 'fetchMore'>;

// Re-export the Query, giving us a place to put zapier overrides in the future if need be
export default Query;
